import React from 'react'
import { ReactComponent as Box } from 'assets/icons/Box.svg'

import style from '../styles/goods.module.scss'

const EmptyList = () => {
  return (
    <div className={style.empty}>
      <Box/>
      <p className={style.empty__title}>Товаров пока нет</p>
      <p className={style.empty__description}>Скоро здесь обязательно появится что-то новое</p>
    </div>
  )
}

export default EmptyList